<template>
    <v-card>
        <div class="d-flex justify-space-between flex-wrap">
            <div>
                <v-card-title>INSTITUCIÓN</v-card-title>
                <v-card-subtitle class="text-overline pb-4">{{ user.username }}</v-card-subtitle>
            </div>
            <div>
                <div class="d-flex">
                    <ColorMode class="mr-2"/>
                    <v-card flat :loading="logouting" v-on:click="logout()">
                        <v-card-text class="px-5 py-0 text-center">
                            <small class="overline d-flex align-center"><v-icon class="mr-1" small>mdi-logout-variant</v-icon><span>CERRAR SESIÓN</span></small>
                        </v-card-text>
                    </v-card>
                </div>
            </div>
        </div>
        <v-divider/>
        <v-card-text>
            <Search :default="params" @search="search($event)" :loading="loading"/>
            <Reporte :params="params" :loading.sync="loading"/>
        </v-card-text>
    </v-card>
</template>
<script>
import Search from '@/components/entities/institution/reporte/search.vue';
import ColorMode from '@components/layout/components/colormode';
import Reporte from '@components/entities/institution/reporte';

export default {
    components: {
        Search,
        ColorMode,
        Reporte
    },
    data: function () {
        return {
            logouting: false,
            loading: false,
            params: {
                daterange: [this.$luxon.now().toISODate(),this.$luxon.now().toISODate()],
            },
        }
    },
    computed: {
        user: function () {
			return this.$store.getters['persist/auth/user'];
		},
    },
    methods:{
        search: function (params) {
            this.params = {
                ... params,
            };
        },
        logout: function () {
            this.logouting = true;
            this.$store.dispatch('persist/auth/logout').finally(() => this.logouting = false);
        }
    },
}
</script>